import { Button, Popover, PopoverSurface, PopoverTrigger } from '@fluentui/react-components';
import React, { useState } from 'react';
import './IconPicker.css';
import { IconPickerList } from './IconPickerList';
import { MaterialIcon } from './IconRegistry';

export interface IconPickerProps {
  defaultValue?: string;
  onChange: (iconName: string) => void;
  'aria-describedby'?: string;
}

export const IconPicker: React.FC<IconPickerProps> = (props) => {
  const [selectedIconName, setSelectedIconName] = useState<string>(props.defaultValue ?? 'link');
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);

  const handleOpenChange = (_e: unknown, data: { open: boolean }) => {
    setIsPopupOpen(data.open);
  };

  const handleIconSelected = (iconName: string) => {
    setIsPopupOpen(false);
    setSelectedIconName(iconName);
    props.onChange(iconName);
  };

  return (
    <Popover positioning="above" withArrow open={isPopupOpen} onOpenChange={handleOpenChange}>
      <PopoverTrigger disableButtonEnhancement>
        <Button
          aria-describedby={props['aria-describedby']}
          className="iconPickerTriggerButton"
          icon={<MaterialIcon name={selectedIconName} />}
        />
      </PopoverTrigger>
      <PopoverSurface>
        <div className="iconPickerPopupContent">
          <IconPickerList selectedIconName={selectedIconName} onIconSelected={handleIconSelected} />
        </div>
      </PopoverSurface>
    </Popover>
  );
};
